<template>
  <div id="custom-footer-page" class="custom-footer-page">
    <div  class="custom-footer">
    <div class="copy">
      <b class="currentYear"> ©  {{ currentYear }}  <a href="https://www.empreinte.com/" target="_blank" class="a_footer"> EMPREINTE </a></b>
    </div>
    <div class="footer-nav">

      <span class="item-footer"> <a href="https://www.empreinte.com/mentions-legales/" target="_blank" class="a_footer"> Légal </a>  </span>
      <span>|</span>
      <span class="item-footer"> <a href="https://www.empreinte.com/mentions-legales/" target="_blank" class="a_footer"> Licence </a> </span>
      <span>|</span>
      <span class="item-footer"> <a href="https://www.empreinte.com/" target="_blank" class="a_footer"> Contact </a> </span>

    </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'CustomFooter',
    computed: {
      ...mapGetters({
        componentStyle: 'layout/getComponentStyle',
      }),
      currentYear() {
        return new Date().getFullYear();
      },
      clientName() {
        return process.env.CLIENT_NAME;
      },

    },
  };
</script>

<style lang="scss">

  .darkMode{
    .a_footer , .currentYear{
      color:#ffffff!important; ;
    }
    .a_footer:hover{
      color:#ffffff !important ;
      text-decoration:none!important;
    }
    .custom-footer-page{
      background-color: #2a2a2a;

    }
  }


  .currentYear{
    font-family: Roboto;

  }
  .content {
    background-color: #e8e8e8;

  }
  .a_footer{
    color:#000000 ;
  }
  .a_footer:hover{
    color:#000000 !important ;
    text-decoration:none!important;
  }
  .item-footer{
    cursor: pointer;
    font-family: Roboto;
  }

  .custom-footer-page{
    z-index: 99;
    align-items: center;
    background-color: #e8e8e8;
    position: sticky;
    bottom: 0;
    width: calc(100% + 30px);
    margin-left: -15px;
  }

  @media (min-width: 1600px){


  .custom-footer {
    max-width: 1400px !important;
  }
  }

  @media (min-width: 992px){
  .custom-footer {
    max-width: 1117px;
  }}





  .custom-footer {
    align-items: center;
    justify-content: space-between;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    padding-right: 25px;
    padding-left: 25px;
    margin-right: auto;
    margin-left: auto;
    min-height: 58px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CustomComponents/CustomFooter.vue